<div class="detail-center">
    <div class="detail-content">
        <div *ngIf="parkDetail">
            <p> 
                Parking Place Vehicles
                <button mat-button matSuffix mat-icon-button aria-label="Clear" color="danger" (click)="addChargeStation()"><mat-icon>add_circle</mat-icon></button>
            </p>
            <div *ngFor="let element of parkDetail">
                <div class="park-place-charge-stations">
                    <p>{{ element.id }} - {{ element.vehicle }} </p>
                    <button mat-button matSuffix mat-icon-button aria-label="Clear" color="danger" (click)="removeChargeStation(element.id)"><mat-icon>remove_circle</mat-icon></button>
                </div>
            </div>
        </div>
    </div>
</div>